import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'ms-button-speed-dial',
	templateUrl: './ms-button-speed-dial.component.html',
	styleUrls: ['./ms-button-speed-dial.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsButtonSpeedDialComponent implements OnInit, OnDestroy {
	@Input({ alias: 'items', required: true })
	public _items = [];
	@Input()
	title: string | null;

	/**
	 * Constructor
	 */
	constructor() {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
